<a mat-list-item
   [ngStyle]="{'padding-left': (depth * 15) + 'px'}"
   (click)="onItemSelected(item)"
   [ngClass]="{'active': item.route ? router.isActive(item.route, true) : false, 'expanded' : expanded}"
   tabindex="0">
  {{ item.displayName }}
  <span fxFlex *ngIf="item.children && item.children.length">
    <span fxFlex></span>
    <mat-icon [@indicatorRotate]="expanded ? 'expanded' : 'collapsed'">
      expand_more
    </mat-icon>
  </span>
</a>
<div *ngIf="expanded">
  <Teranet-SideMenuItem *ngFor="let child of item.children" [item]="child" [depth]="depth + 1"></Teranet-SideMenuItem>
</div>

